import { attemptRefresh } from "./authFetch";

export interface Session {
  authenticated: boolean;
  role?: string;
}

const GAME_MANAGER = "GAME_MANAGER";

export async function fetchSession(): Promise<Session> {
  if (import.meta.env.DEV) {
    return { authenticated: true, role: GAME_MANAGER };
  }
  let response = await fetch(`${import.meta.env.VITE_API_BASE}/v1/auth/me`, {
    credentials: "include",
  });
  if (!response.ok) {
    const refreshed = await attemptRefresh();
    if (!refreshed) return { authenticated: false };
    response = await fetch(`${import.meta.env.VITE_API_BASE}/v1/auth/me`, {
      credentials: "include",
    });
    if (!response.ok) return { authenticated: false };
  }
  const user = (await response.json().catch(() => null)) as { role?: string } | null;
  return { authenticated: true, role: user?.role };
}

export function isGameManager(session: Session): boolean {
  return session.authenticated && session.role === GAME_MANAGER;
}
